import CategoriesTab from './CategoriesTab'
export default CategoriesTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/Hotels24Tab/MappingTabs/CategoriesTab/index.js